module.exports = __webpack_public_path__ + "static/media/melo5.03a0a1ae.ogg";